import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-family: 'Inter';
  background-color: transparent;
`;

export const Button = styled.button`
  min-width: 38px;
  min-height: 32px;
  background-color: ${props => props.theme.colors.white};
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter';

  &:hover {
    background-color: ${props => props.theme.colors.hoverBg};
  }
`;

export const DropdownMenu = styled.div`
  position: fixed;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  width: 150px;
  font-family: 'Inter';
  opacity: 1;
  transition: transform 0.2s ease, opacity 0.2s ease;
  margin-top: 4px;
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 8px 16px;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Inter';

  &:hover {
    background: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
`; 